// src/pages/EditarDescuento.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from '../Config';

const EditarDescuento = () => {
  const { id } = useParams();
  const [productoId, setProductoId] = useState('');
  const [productos, setProductos] = useState([]);
  const [porcentajeDescuento, setPorcentajeDescuento] = useState('');
  const [fecha, setFecha] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        const [resDescuento, resProductos] = await Promise.all([
          axios.get(`${API_BASE_URL}api/descuentos/${id}`),
          axios.get(`${API_BASE_URL}/api/productos`)
        ]);

        const data = resDescuento.data;
        setProductoId(data.productoId);
        setPorcentajeDescuento(data.porcentajeDescuento);
        setFecha(data.fecha);
        setProductos(resProductos.data);
      } catch (error) {
        console.error('Error al cargar datos', error);
        setMensaje('❌ Error al cargar el descuento');
      }
    };

    fetchDatos();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/api/descuentos/${id}`, {
        productoId: parseInt(productoId),
        porcentajeDescuento: parseFloat(porcentajeDescuento),
        fecha
      });
      setMensaje('✅ Descuento actualizado');
      setTimeout(() => navigate('/admin-promociones'), 1500);
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al actualizar descuento');
    }
  };

  const handleEliminar = async () => {
    try {
      await axios.delete(`${API_BASE_URL}/api/descuentos/${id}`);
      setMensaje('🗑️ Descuento eliminado');
      setTimeout(() => navigate('/admin-promociones'), 1500);
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al eliminar descuento');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Editar Descuento</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1">Producto:</label>
            <select
              value={productoId}
              onChange={(e) => setProductoId(e.target.value)}
              required
              className="w-full border p-2 rounded"
            >
              <option value="">Seleccione un producto</option>
              {productos.map((prod) => (
                <option key={prod.id} value={prod.id}>{prod.nombre}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block mb-1">Porcentaje (%):</label>
            <input
              type="number"
              value={porcentajeDescuento}
              onChange={(e) => setPorcentajeDescuento(e.target.value)}
              required
              min="0"
              max="100"
              step="0.01"
              className="w-full border p-2 rounded"
            />
          </div>
          <div>
            <label className="block mb-1">Fecha:</label>
            <input
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              required
              className="w-full border p-2 rounded"
            />
          </div>
          <div className="flex gap-4">
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Guardar Cambios
            </button>
            <button
              type="button"
              onClick={handleEliminar}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Eliminar
            </button>
          </div>
        </form>
        {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
      </div>
    </div>
  );
};

export default EditarDescuento;
